// Add your own custom JS here.

// Configure Focus-Trap for Tooltip Popovers
(function() {
  function configureTooltipFocusTraps() {
    const tooltipPopovers = document.querySelectorAll('.custom-text-block__tooltip');
    tooltipPopovers.forEach(function(popover) {
      // Setze Focus-Trap-Optionen mit fallbackFocus, damit es auch ohne tabbable Nodes funktioniert
      popover.focusTrapOptions = {
        allowOutsideClick: true,
        clickOutsideDeactivates: true,
        fallbackFocus: popover
      };
    });
  }

  configureTooltipFocusTraps();
})();

// Custom Text Block Tooltips
(function() {
  // Warte bis DOM geladen ist
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomTextTooltips);
  } else {
    initCustomTextTooltips();
  }
  
  function positionTooltipPopover(popover, button) {
    // Reset previous positioning
    popover.style.left = '';
    popover.style.right = '';
    popover.style.top = '';
    popover.style.bottom = '';
    popover.style.maxWidth = '';
    popover.style.width = '';
    
    // Get button and icon wrapper positions
    const buttonRect = button.getBoundingClientRect();
    const iconWrapper = button.closest('.custom-text-block__icon-wrapper');
    const iconWrapperRect = iconWrapper ? iconWrapper.getBoundingClientRect() : buttonRect;
    
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const padding = 16; // Minimum distance from viewport edge
    
    // Temporarily make popover visible to measure dimensions accurately
    const originalVisibility = popover.style.visibility;
    const originalOpacity = popover.style.opacity;
    popover.style.visibility = 'visible';
    popover.style.opacity = '0';
    popover.style.position = 'absolute';
    
    // Force reflow to ensure dimensions are calculated
    void popover.offsetWidth;
    
    // Get popover dimensions
    const popoverWidth = popover.offsetWidth || popover.scrollWidth || 300;
    const popoverHeight = popover.offsetHeight || popover.scrollHeight || 100;
    
    // Restore original visibility settings
    popover.style.visibility = originalVisibility || '';
    popover.style.opacity = originalOpacity || '';
    
    // Feste Tooltip-Breite
    const tooltipWidth = 200;
    popover.style.width = tooltipWidth + 'px';
    popover.style.maxWidth = tooltipWidth + 'px';
    
    // Calculate available space for vertical positioning
    const spaceBelow = viewportHeight - buttonRect.bottom;
    const spaceAbove = buttonRect.top;
    
    // Verfügbaren Platz berechnen
    const spaceRight = viewportWidth - buttonRect.right;
    const spaceLeft = buttonRect.left;
    
    // Icon-Position im Viewport analysieren
    const iconCenterX = buttonRect.left + buttonRect.width / 2;
    const viewportThird = viewportWidth / 3;
    
    // Beste Positionierung wählen basierend auf Icon-Position
    let position = 'right'; // default: nach rechts
    
    if (iconCenterX < viewportThird) {
      // Icon links - Tooltip nach rechts
      if (spaceRight >= tooltipWidth + padding) {
        position = 'right';
      } else {
        // Nicht genug Platz rechts - nach links
        position = 'left';
      }
    } else if (iconCenterX > viewportWidth * 2 / 3) {
      // Icon rechts - Tooltip nach links
      if (spaceLeft >= tooltipWidth + padding) {
        position = 'left';
      } else {
        // Nicht genug Platz links - nach rechts
        position = 'right';
      }
    } else {
      // Icon mittig - beste Richtung wählen
      if (spaceRight >= spaceLeft && spaceRight >= tooltipWidth + padding) {
        position = 'right';
      } else if (spaceLeft >= tooltipWidth + padding) {
        position = 'left';
      } else {
        // Nicht genug Platz auf beiden Seiten - zentriert mit Anpassung
        position = 'center';
      }
    }
    
    // Position setzen relativ zum Icon-Wrapper
    if (position === 'right') {
      // Tooltip nach rechts (left: 0, relativ zum Icon-Wrapper)
      popover.style.left = '0';
      popover.style.right = 'auto';
    } else if (position === 'left') {
      // Tooltip nach links (right: 0, relativ zum Icon-Wrapper)
      popover.style.right = '0';
      popover.style.left = 'auto';
    } else {
      // Zentriert: Icon-Mitte minus Tooltip-Hälfte
      const iconCenterRelative = buttonRect.left + buttonRect.width / 2 - iconWrapperRect.left;
      popover.style.left = (iconCenterRelative - tooltipWidth / 2) + 'px';
      popover.style.right = 'auto';
    }
    
    // Viewport-Grenzen prüfen und anpassen
    requestAnimationFrame(function() {
      const finalRect = popover.getBoundingClientRect();
      if (finalRect.left < padding) {
        // Tooltip würde links überlaufen - anpassen
        const adjust = padding - finalRect.left;
        const currentLeft = parseFloat(popover.style.left) || 0;
        const currentRight = popover.style.right;
        if (currentRight === 'auto' || currentRight === '') {
          popover.style.left = (currentLeft + adjust) + 'px';
        } else {
          // Wenn right gesetzt ist, umrechnen
          const rightValue = parseFloat(popover.style.right) || 0;
          popover.style.right = (rightValue - adjust) + 'px';
        }
      }
      if (finalRect.right > viewportWidth - padding) {
        // Tooltip würde rechts überlaufen - anpassen
        const adjust = finalRect.right - (viewportWidth - padding);
        const currentLeft = parseFloat(popover.style.left) || 0;
        const currentRight = popover.style.right;
        if (currentRight === 'auto' || currentRight === '') {
          popover.style.left = (currentLeft - adjust) + 'px';
        } else {
          // Wenn right gesetzt ist, umrechnen
          const rightValue = parseFloat(popover.style.right) || 0;
          popover.style.right = (rightValue + adjust) + 'px';
        }
      }
    });
    
    // Determine vertical position
    if (spaceBelow < popoverHeight + padding && spaceAbove > spaceBelow) {
      // Not enough space below, more space above - position above button
      popover.style.top = 'auto';
      popover.style.bottom = '100%';
      popover.style.marginTop = '0';
      popover.style.marginBottom = '0.5em';
    } else {
      // Default: position below button
      popover.style.top = '100%';
      popover.style.bottom = 'auto';
      popover.style.marginTop = '0.5em';
      popover.style.marginBottom = '0';
    }
    
    // Stelle sicher, dass CSS-Regeln für Sichtbarkeit greifen (wenn Popover geöffnet ist)
    if (popover.hasAttribute('open')) {
      popover.style.visibility = '';
      popover.style.opacity = '';
    }
  }
  
  function initCustomTextTooltips() {
    const tooltipButtons = document.querySelectorAll('[aria-controls^="CustomTextTooltip-"]');

    tooltipButtons.forEach(function(tooltipButton) {
      // Verhindere doppelte Initialisierung
      if (tooltipButton.hasAttribute('data-custom-tooltip-initialized')) {
        return;
      }

      const popoverId = tooltipButton.getAttribute('aria-controls');
      const tooltipPopover = document.getElementById(popoverId);

      if (!tooltipPopover) {
        return;
      }

      // Markiere Button als initialisiert
      tooltipButton.setAttribute('data-custom-tooltip-initialized', '');

      // Focus-Trap-Optionen (wirkt nur nach Custom-Element-Upgrade)
      if (tooltipPopover.focusTrapOptions !== undefined) {
        tooltipPopover.focusTrapOptions = {
          allowOutsideClick: true,
          clickOutsideDeactivates: true,
          fallbackFocus: tooltipPopover
        };
      }

      // Öffnen/Schließen über Attribut (funktioniert auch vor Custom-Element-Upgrade)
      function isPopoverOpen() {
        return tooltipPopover.hasAttribute('open');
      }
      function setPopoverOpen(open) {
        if (open) {
          tooltipPopover.setAttribute('open', '');
        } else {
          tooltipPopover.removeAttribute('open');
        }
      }

      tooltipButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const wasOpen = isPopoverOpen();
        setPopoverOpen(!wasOpen);
        const nowOpen = isPopoverOpen();
        tooltipButton.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
      });

      document.addEventListener('click', function(e) {
        if (!isPopoverOpen()) return;
        if (tooltipPopover.contains(e.target) || tooltipButton.contains(e.target)) return;
        setPopoverOpen(false);
        tooltipButton.setAttribute('aria-expanded', 'false');
      });

      tooltipPopover.addEventListener('expandable-html-element:close', function() {
        tooltipButton.setAttribute('aria-expanded', 'false');
      });

      tooltipPopover.addEventListener('expandable-html-element:open', function() {
        tooltipButton.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            // Positioniere nur wenn Popover noch geöffnet ist
            if (!tooltipPopover.hasAttribute('open')) {
              return;
            }
            positionTooltipPopover(tooltipPopover, tooltipButton);
          });
        });
      });

      let resizeTimeout;
      window.addEventListener('resize', function() {
        if (!isPopoverOpen()) return;
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          positionTooltipPopover(tooltipPopover, tooltipButton);
        }, 100);
      });
    });
  }
})();

// Select Options Truncation - Ellipsis bei 58px vom rechten Rand
(function() {
  // Erstelle Canvas einmal für alle Messungen
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  
  function truncateSelectOptions() {
    const selects = document.querySelectorAll('.main-product__block-variant-picker .input__select');
    
    selects.forEach(function(select) {
      const selectWidth = select.offsetWidth;
      const ellipsisPosition = 58; // Ellipsis bei 58px vom rechten Rand
      const maxTextWidth = selectWidth - ellipsisPosition;
      
      // Setze Font für präzise Messung
      const fontSize = 18; // Aus CSS
      const fontFamily = 'Arimo, sans-serif'; // Aus CSS
      context.font = fontSize + 'px ' + fontFamily;
      
      // Funktion zum Kürzen eines Textes
      function truncateText(text, maxWidth) {
        const textWidth = context.measureText(text).width;
        
        if (textWidth <= maxWidth) {
          return text;
        }
        
        // Text ist zu lang - finde die richtige Stelle zum Kürzen
        let truncatedText = text;
        let testWidth = context.measureText(truncatedText + '...').width;
        
        // Schrittweise Reduzierung bis Text + "..." passt
        while (testWidth > maxWidth && truncatedText.length > 0) {
          truncatedText = truncatedText.substring(0, truncatedText.length - 1);
          testWidth = context.measureText(truncatedText + '...').width;
        }
        
        return truncatedText + '...';
      }
      
      // Kürze alle Optionen
      const options = select.querySelectorAll('option');
      options.forEach(function(option) {
        // Stelle Original-Text wieder her falls vorhanden
        // Entferne "..." falls vorhanden, um Original-Text zu bekommen
        let currentText = option.textContent;
        if (currentText.endsWith('...')) {
          currentText = currentText.slice(0, -3);
        }
        
        const originalText = option.getAttribute('data-original-text') || currentText;
        if (!option.getAttribute('data-original-text')) {
          option.setAttribute('data-original-text', originalText);
        }
        
        // Kürze Text wenn nötig
        const truncatedText = truncateText(originalText, maxTextWidth);
        option.textContent = truncatedText;
      });
    });
  }
  
  // Beim Laden ausführen
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', truncateSelectOptions);
  } else {
    truncateSelectOptions();
  }
  
  // Bei Resize neu berechnen
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(truncateSelectOptions, 100);
  });
})();
